<template>
  <div>
    <el-card class="mb5">
      <div>
        <el-tabs v-model="activeName" style="margin-top: -10px" @tab-click="handleClick">
          <el-tab-pane
            v-if="showCollect"
            v-permit:remove="'btn:exceptionManagementCenter:Collect'"
            name="0"
          >
            <span slot="label">
              {{ $t('GlobalSetObj.Collect') }}
            </span>
          </el-tab-pane>
          <el-tab-pane
            v-if="showExpress"
            v-permit:remove="'btn:exceptionManagementCenter:Express'"
            name="1"
          ><span slot="label">
            {{ $t('collectionCenter.expressDelivery') }}
          </span>
          </el-tab-pane>
        </el-tabs>
        <el-form v-if="showCollect || showExpress" label-position="top" size="small">
          <el-row :gutter="10">
            <el-col :span="7">
              <!--留言时间-->
              <el-form-item>
                <template slot="label">
                  <div class="selectLabel">
                    <el-select v-model="queryForm.params.timeType">
                      <el-option key="1" :label="$t('orderCenterCont.problemTime')" :value="1" />
                      <template v-if="activeName === '0'">
                        <el-option key="2" :label="$t('collectionCenter.orderCreateT')" :value="2" />
                        <el-option key="3" :label="$t('newOrder.lanshouT')" :value="3" />
                      </template>
                    </el-select>
                  </div>
                </template>
                <el-date-picker
                  v-model="timeValue"
                  :clearable="false"
                  :default-time="['00:00:00', '23:59:59']"
                  :format="$i18n.locale === 'zh' ? zhDate : ptDate"
                  :placeholder="$t('newOrder.SelectDatetime')"
                  range-separator="~"
                  style="width: 100%"
                  type="datetimerange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <!--运单编号-->
              <el-form-item>
                <template slot="label">
                  <div class="selectLabel">
                    <el-select v-model="queryForm.params.numberType">
                      <template v-if="activeName === '0'">
                        <el-option
                          key="1"
                          :label="$t('collectionCenter.Barcode')"
                          :value="0"
                        /><!--条形码-->
                        <el-option
                          key="2"
                          :label="$t('collectionCenter.lanshouOrderNum')"
                          :value="1"
                        /><!--揽收订单号-->
                        <el-option
                          key="3"
                          :label="$t('collectionCenter.customerOrderNum')"
                          :value="2"
                        /><!--客户订单号-->
                      </template>
                      <template v-else>
                        <el-option
                          key="2"
                          :label="$t('collectionCenter.waybillNumber')"
                          :value="3"
                        /><!--运单号-->
                        <el-option
                          key="3"
                          :label="$t('GlobalSetObj.ScanNumber')"
                          :value="4"
                        /><!--扫描单号-->
                      </template>
                    </el-select>
                  </div>
                </template>
                <el-input
                  v-model="queryForm.params.inputValue"
                  :placeholder="$t('GlobalSetObj.CanBeEnteredMultiple2000')"
                  :rows="1"
                  type="textarea"
                />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <!--客户名称-->
              <el-form-item :label="$t('orderCenterCont.CustomerName')">
                <el-select
                  v-model="queryForm.params.customerIdList"
                  :placeholder="$t('collectionCenter.pleaseChoose')"
                  :remote-method="getCustomerPage"
                  clearable
                  collapse-tags
                  filterable
                  multiple
                  remote
                  reserve-keyword
                  style="width: 100%"
                  @clear="getCustomerPage('')"
                  @focus="getCustomerPage('', true)"
                >
                  <el-option
                    v-for="item in customerNameList"
                    :key="item.id"
                    :label="item.username"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <!--商户名称-->
              <el-form-item :label="$t('collectionCenter.MerchantName')" size="small">
                <el-select
                  v-model="queryForm.params.merchantCodeList"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  :remote-method="getMerchantList"
                  clearable
                  collapse-tags
                  filterable
                  multiple
                  remote
                  reserve-keyword
                  style="width: 100%"
                  @clear="getMerchantList('')"
                  @focus="getMerchantList('', true)"
                >
                  <el-option
                    v-for="item in merchantList"
                    :key="item.merchantCode"
                    :label="`${item.merchantName} - ${item.merchantCode}`"
                    :value="item.merchantCode"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col v-if="activeName === '1'" :span="4">
              <!--登记人网点-->
              <el-form-item>
                <template slot="label">
                  <div class="selectLabel">
                    <el-select v-model="queryForm.params.siteType">
                      <el-option key="1" :label="$t('driver.registrantHub')" :value="0" />
                      <el-option key="2" :label="$t('GlobalSetObj.preEntrega')" :value="1" />
                    </el-select>
                  </div>
                </template>
                <el-select
                  v-model="queryForm.params.siteSelectList"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  :remote-method="remoteGetSiteList"
                  clearable
                  filterable
                  multiple
                  remote
                  reserve-keyword
                  style="width: 100%"
                  @focus="remoteGetSiteList('')"
                >
                  <el-option
                    v-for="item in siteList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <!--订单状态-->
              <el-form-item label="">
                <template slot="label">
                  <div v-if="activeName === '0'">{{ $t('compensationManagement.orderStatus') }}</div>
                  <div v-else>{{ $t('collectionCenter.shipmentStatus') }}</div>
                </template>
                <el-select
                  v-model="queryForm.params.collectStatusList"
                  :placeholder="$t('GlobalSetObj.all')"
                  clearable
                  filterable
                  multiple
                  size="small"
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, ind) in selectStatusList"
                    :key="ind"
                    :label="item.label"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <!--问题件原因-->
              <el-form-item :label="$t('GlobalSetObj.problemReason')">
                <el-select
                  v-model="queryForm.params.problemTypeIdList"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  clearable
                  filterable
                  multiple
                  style="width: 100%"
                  @focus="handleFocus"
                >
                  <el-option
                    v-for="item in causeProblemPageList"
                    :key="item.id"
                    :label="item.dictDescribe"
                    :value="item.problemId"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="activeName === '1'" :span="4">
              <!--收件人州-->
              <el-form-item :label="$t('newOrder.RecipientState')" size="small">
                <el-select
                  v-model="queryForm.params.receiveStates"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  clearable
                  filterable
                  multiple
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in StateList"
                    :key="item.id"
                    :label="item.label"
                    :value="item.label"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="activeName === '1'" :span="4">
              <!-- 地址类型问题 -->
              <el-form-item :label="$t('login.addressIssueType')" size="small">
                <el-select
                  v-model="queryForm.params.addressIssueTypeList"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  clearable
                  filterable
                  multiple
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in addressProblemList"
                    :key="item.code"
                    :label="item.label"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4" style="width: auto">
              <div style="margin-top: 27px">
                <!--搜索-->
                <el-button size="small" type="primary" @click="enterSearch">{{ $t('newOrder.search') }}
                </el-button>
                <!--重置-->
                <el-button size="small" type="info" @click="resetForm()">{{ $t('newOrder.reset') }}
                </el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
        <div v-if="showCollect || showExpress">
          <!-- 批量登记 -->
          <el-button size="small" type="primary" @click="clickBatchRegistration">{{ $t('driver.batchRegistration') }}
          </el-button>
          <el-button icon="el-icon-upload2" size="small" @click="exportOrder">
            {{ $t('navbar.export') }}
          </el-button>
          <!--批量单号导出-->
          <el-button size="small" type="primary" @click="orderNumberExport">{{ $t('placeOrder.BatchExport') }}
          </el-button>
        </div>
      </div>
    </el-card>
    <el-card>
      <div v-if="showCollect || showExpress" class="box-card" style="margin-top: 10px">
        <!--  表格数据  -->
        <el-table
          v-show="activeName === '0'"
          ref="tableRef"
          :data="tableData"
          :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
          border
          height="520"
          style="width: 100%"
        >
          <el-table-column
            :label="$t('GlobalSetObj.serial')"
            align="center"
            type="index"
            width="70"
          />
          <el-table-column :label="$t('orderCenterCont.problemTime')" prop="createTime" width="160" />
          <el-table-column
            :label="$t('collectionCenter.lanshouOrderNum')"
            prop="orderNumber"
            width="170"
          />
          <el-table-column :label="$t('collectionCenter.Barcode')" prop="scanNumber" width="150" />
          <el-table-column
            :label="$t('collectionCenter.customerOrderNum')"
            prop="customerNumber"
            width="170"
          />
          <el-table-column
            :label="$t('orderCenterCont.CustomerName')"
            prop="customerName"
            width="170"
          />
          <el-table-column
            :label="$t('collectionCenter.MerchantName')"
            :show-overflow-tooltip="true"
            prop="merchantName"
            width="160"
          />
          <el-table-column
            :label="$t('compensationManagement.orderStatus')"
            prop="collectStatusName"
            width="170"
          />
          <el-table-column
            :label="$t('newOrder.orderCreateTime')"
            prop="orderCreateTime"
            width="170"
          />
          <el-table-column
            :label="$t('newOrder.clientExitTime')"
            prop="customerSendTime"
            width="170"
          />
          <el-table-column :label="$t('newOrder.lanshouT')" prop="scanTime" width="160" />
          <el-table-column
            :label="$t('GlobalSetObj.problemReason')"
            prop="problemTypeName"
            width="160"
          />
          <el-table-column :label="$t('collectionCenter.picture')" prop="problemImg" width="160">
            <template slot-scope="scope">
              <div class="verifier" @click="imageSee(scope.row)">
                {{ scope.row.problemImg ? $t('home.clickSee') : '--' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('GlobalSetObj.remark')" prop="problemReason" width="160" />
          <el-table-column :label="$t('collectionCenter.registrar')" prop="problemName" width="160" />
          <el-table-column
            :label="$t('driver.registrantHub')"
            prop="registrantSiteName"
            width="160"
          />
          <!--登记位置经度-->
          <el-table-column
            :label="$t('collectionCenter.RegistrationPositionLongitude')"
            prop="registrationLng"
            width="160"
          />
          <!--登记位置纬度-->
          <el-table-column
            :label="$t('collectionCenter.RegistrationPositionLatitude')"
            prop="registrationLat"
            width="160"
          />
          <!--距收件地址距离(M)-->
          <el-table-column
            :label="$t('collectionCenter.DistanceFromReceivingAddress') + '(M)'"
            prop="distanceToRecipient"
            width="160"
          />
        </el-table>
        <el-table
          v-show="activeName === '1'"
          ref="tableRef"
          :data="tableData"
          :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
          border
          height="520"
          style="width: 100%"
        >
          <el-table-column
            :label="$t('GlobalSetObj.serial')"
            align="center"
            type="index"
            width="70"
          />
          <el-table-column :label="$t('orderCenterCont.problemTime')" prop="createTime" width="160" />
          <el-table-column
            :label="$t('collectionCenter.waybillNumber')"
            prop="orderNumber"
            width="170"
          />
          <el-table-column :label="$t('GlobalSetObj.ScanNumber')" prop="scanNumber" width="150" />
          <el-table-column
            :label="$t('newOrder.waybillStatus')"
            prop="waybillStatusName"
            width="170"
          />
          <el-table-column
            :label="$t('GlobalSetObj.problemReason')"
            prop="problemTypeName"
            width="160"
          />
          <el-table-column
            :label="$t('login.addressIssueType')"
            prop="addressIssueTypeName"
            width="160"
          />
          <!--  破损物品   -->
          <el-table-column
            :label="$t('scripting.damagedItems')"
            prop="damagedItemsTypeName"
            width="150"
          />
          <el-table-column
            :label="$t('orderCenterCont.CustomerName')"
            prop="customerName"
            width="170"
          />
          <el-table-column
            :label="$t('collectionCenter.MerchantName')"
            :show-overflow-tooltip="true"
            prop="merchantName"
            width="160"
          />
          <el-table-column
            :label="$t('orderCenterCont.BelongsToTheRegion')"
            prop="regionName"
            width="160"
          />
          <el-table-column
            :label="$t('GlobalSetObj.preEntrega')"
            prop="preDeliverStationName"
            width="160"
          />
          <el-table-column :label="$t('newOrder.RecipientState')" prop="receiveState" width="160" />
          <el-table-column :label="$t('Resource.picture')" prop="problemImg" width="160">
            <template slot-scope="scope">
              <div class="verifier" @click="imageSee(scope.row)">
                {{ scope.row.problemImg ? $t('home.clickSee') : '--' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('GlobalSetObj.remark')" prop="problemReason" width="160" />
          <el-table-column :label="$t('collectionCenter.registrar')" prop="problemName" width="160" />
          <el-table-column
            :label="$t('driver.registrantHub')"
            prop="registrantSiteName"
            width="160"
          />
          <!--登记位置经度-->
          <el-table-column
            :label="$t('collectionCenter.RegistrationPositionLongitude')"
            prop="registrationLng"
            width="160"
          />
          <!--登记位置纬度-->
          <el-table-column
            :label="$t('collectionCenter.RegistrationPositionLatitude')"
            prop="registrationLat"
            width="160"
          />
          <!--距收件地址距离(M)-->
          <el-table-column
            :label="$t('collectionCenter.DistanceFromReceivingAddress') + '(M)'"
            prop="distanceToRecipient"
            width="160"
          />
        </el-table>
        <!--  分页  -->
        <el-pagination
          :current-page="queryForm.pageNumber"
          :page-size="queryForm.pageSize"
          :page-sizes="[10, 50, 100, 500, 1000]"
          :total="queryForm.total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="margin: 10px 0; float: right"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
        <batchRegistration
          ref="batchRegistrationRef"
          :active-name="activeName"
          :cause-problem-list="causeProblemList"
          @search="enterSearch"
        />
        <imageSeeDialog ref="imageSeeDialogRef" />
      </div>
    </el-card>
    <div v-if="!showCollect && !showExpress" class="flx-center" style="font-size: 25px">
      {{ $t('driver.grantSubpagePermission') }}
    </div>
    <!--批量导出-->
    <orderNumberExport ref="OrderExport" />
    <exportTip ref="exportTipRef" />
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { collectProblemPage, problemOps, problemQuery, siteFuzzyQuery } from '@/api/lanshou';
import { apiCustomerPage, apimerchantName } from '@/api/customer';
import { waybillStatusList } from '@/utils/enumData';
import { getLgAreaListData } from '@/api/orderApi';
import imageSeeDialog from '@/components/imageSeeDialog/index.vue';
import orderNumberExport from './component/orderExport.vue';

export default {
  name: 'ProblemRecord',
  components: {
    orderNumberExport,
    imageSeeDialog,
    batchRegistration: () => import('./component/batchRegistration.vue'),
    exportTip: () => import('./component/exportTip.vue')
  },
  data() {
    return {
      hasLoaded: false, // 避免重复加载
      zhDate: 'yyyy-MM-dd HH:mm:ss',
      ptDate: 'dd-MM-yyyy HH:mm:ss',
      timeValue: [],
      tableData: [],
      siteList: [],
      merchantList: [],
      customerNameList: [],
      tipDialog: false,
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        total: 0,
        params: {
          siteType: 0,
          collectStatusList: [],
          siteSelectList: [],
          customerIdList: [], // 客户名称
          merchantCodeList: [], // 商户号
          inputValue: '',
          receiveStates: [],
          problemTypeIdList: [], // 问题件原因
          numberType: 0, // 单号类型: 0-运单号, 1-扫描单号
          timeType: 1, // 时间类型: 1-登记时间, 2-最新回复时间
          addressIssueTypeList: []
        }
      },
      activeName: '0',
      waybillStatusList: waybillStatusList,
      StateList: [],
      selectStatusList: [
        { code: 0, label: this.$t('collectionCenter.notLanShou') }, // '未揽收'
        { code: 1, label: this.$t('collectionCenter.hasLanShou') }, // '已揽收'
        { code: 2, label: this.$t('collectionCenter.cancelled') }, // 已取消
        // { code: 3, label: this.$t('collectionCenter.LanShouing') }, // 揽收中
        { code: 4, label: this.$t('collectionCenter.scheduled') }, // 已调度
        { code: 5, label: this.$t('collectionCenter.AbnormalLanShou') }, // 揽收异常
        { code: 6, label: this.$t('collectionCenter.haveBeenSigned') }, // 已签收
        { code: 7, label: this.$t('collectionCenter.ProblemPiece') }, // 问题件
        { code: 8, label: this.$t('collectionCenter.SealedBag') }, // 已封袋
        { code: 9, label: this.$t('collectionCenter.truckLoading') }, // 装车
        { code: 10, label: this.$t('collectionCenter.unloading') }, // 卸车
        { code: 11, label: this.$t('collectionCenter.Bagged') }, // 已装袋
        { code: 12, label: this.$t('collectionCenter.closedLoop') }, // 已闭环
        { code: 13, label: this.$t('collectionCenter.unclaimed') }, // 待取件
        {
          code: 14,
          label: this.$t('collectionCenter.collectionPointInventory')
        } // 揽收网点入库
      ],
      causeProblemList: [],
      showCollect: false,
      showExpress: false,
      causeProblemPageList: [],
      addressProblemList: [
        { code: 1, label: this.$t('login.STREET_ERROR') },
        { code: 2, label: this.$t('login.HOUSE_NUMBER_ERROR') },
        { code: 3, label: this.$t('login.HOUSE_NUMBER_MISSING') },
        { code: 4, label: this.$t('login.OTHER') }
      ]
    };
  },
  watch: {
    activeName(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.hasLoaded = false;
        this.causeProblemPageList = [];
      }
    }
  },
  created() {
    const buttonPermissions = this.$store.getters.button_permissions;
    this.showCollect = buttonPermissions.includes('btn:exceptionManagementCenter:Collect');
    this.showExpress = buttonPermissions.includes('btn:exceptionManagementCenter:Express');
    //  通过权限判断是否显示对应的tab
    if (this.showCollect) {
      this.activeName = '0';
      this.queryForm.params.numberType = 0;
    }
    if (this.showExpress) {
      this.activeName = '1';
      this.queryForm.params.numberType = 3;
    }
    if (this.showCollect && this.showExpress) {
      this.activeName = '0';
      this.queryForm.params.numberType = 0;
    }
    this.getTimer(); // 默认时间
    this.getSearch(); // 查询投诉列表
    this.problemTypeChange();
    this.getAddress();
  },
  methods: {
    // 批量导出单号
    orderNumberExport() {
      this.$refs.OrderExport.handleOpen(this.activeName);
    },
    // 点击查看 图片
    imageSee(row) {
      console.log(row, 'row');
      if (row.problemImg && row.problemImgList && row.problemImgList.length > 0) {
        this.imageList = row.problemImgList.map((item) => {
          return item + '?imageMogr2/thumbnail/2000x2000>/quality/80/format/jpg/ignore-error/1';
        });
        this.$refs.imageSeeDialogRef.showImageFun(this.imageList);
      }
    },
    getCustomerPage(name = '', flag) {
      const param = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          quickSearch: ''
        }
      };
      if (flag) {
        if (this.customerNameList.length === 0) {
          apiCustomerPage(param).then((res) => {
            if (res.code === 200) {
              this.customerNameList = res.data.records;
            }
          });
        }
      } else {
        param.params.quickSearch = name;
        apiCustomerPage(param).then((res) => {
          if (res.code === 200) {
            this.customerNameList = res.data.records;
          }
        });
      }
    },
    // 点击批量登记
    clickBatchRegistration() {
      this.$refs.batchRegistrationRef.showDrawer();
    },
    handleClick(val) {
      this.queryForm.params = {
        siteType: 0,
        collectStatusList: [],
        siteSelectList: [],
        customerIdList: [], // 客户名称
        merchantCodeList: [], // 商户号
        problemItemType: Number(this.activeName),
        inputValue: '',
        receiveStates: [],
        problemTypeIdList: [], // 问题件原因
        numberType: 0, // 单号类型: 0-运单号, 1-扫描单号
        timeType: 1, // 时间类型: 1-登记时间, 2-最新回复时间
        addressIssueTypeList: []
      };
      console.log(val.name, 'handleClick');
      //  不同的 tab  对应不同的状态
      if (val.name === '0') {
        this.selectStatusList = [
          { code: 0, label: this.$t('collectionCenter.notLanShou') }, // '未揽收'
          { code: 1, label: this.$t('collectionCenter.hasLanShou') }, // '已揽收'
          { code: 2, label: this.$t('collectionCenter.cancelled') }, // 已取消
          // { code: 3, label: this.$t('collectionCenter.LanShouing') }, // 揽收中
          { code: 4, label: this.$t('collectionCenter.scheduled') }, // 已调度
          { code: 5, label: this.$t('collectionCenter.AbnormalLanShou') }, // 揽收异常
          { code: 6, label: this.$t('collectionCenter.haveBeenSigned') }, // 已签收
          { code: 7, label: this.$t('collectionCenter.ProblemPiece') }, // 问题件
          { code: 8, label: this.$t('collectionCenter.SealedBag') }, // 已封袋
          { code: 9, label: this.$t('collectionCenter.truckLoading') }, // 装车
          { code: 10, label: this.$t('collectionCenter.unloading') }, // 卸车
          { code: 11, label: this.$t('collectionCenter.Bagged') }, // 已装袋
          { code: 12, label: this.$t('collectionCenter.closedLoop') }, // 已闭环
          { code: 13, label: this.$t('collectionCenter.unclaimed') }, // 待取件
          {
            code: 14,
            label: this.$t('collectionCenter.collectionPointInventory')
          } // 揽收网点入库
        ];
      } else {
        this.selectStatusList = waybillStatusList;
        this.queryForm.params.numberType = 3;
        this.queryForm.params.timeType = 1;
      }
      this.queryForm.pageNumber = 1;
      this.getTimer();
      this.getSearch();
      this.problemTypeChange();
    },
    // 问题件原因————操作
    problemTypeChange() {
      const data = Number(this.activeName);
      problemOps(data).then((res) => {
        this.causeProblemList = [];
        if (res.code === 200) {
          console.log(res.data, 'res.data');
          this.causeProblemList = res.data;
        }
      });
    },
    // 问题件原因————查询
    problemTypePage() {
      this.causeProblemPageList = [];
      const data = Number(this.activeName);
      problemQuery(data).then((res) => {
        if (res.code === 200) {
          this.causeProblemPageList = res.data;
        }
      });
    },
    handleFocus() {
      if (!this.hasLoaded) {
        this.problemTypePage();
        this.hasLoaded = true;
      }
    },
    // 查询条件整理
    queryParam() {
      const params = {
        problemItemType: Number(this.activeName),
        problemCreateStartTime: '',
        problemCreateEndTime: '',
        problemStartTime: '',
        problemEndTime: '',
        closeStartTime: '',
        closeEndTime: '',
        customerIdList: this.queryForm.params.customerIdList,
        merchantCodeList: this.queryForm.params.merchantCodeList,
        problemTypeIdList: this.queryForm.params.problemTypeIdList,
        waybillNumberList: '',
        problemSiteNameList: [],
        preDeliverNameList: [],
        orderNumberList: '',
        packageNumber: '',
        collectStatusList: [],
        waybillStatus: [],
        receiveStates: this.queryForm.params.receiveStates,
        addressIssueTypeList: this.queryForm.params.addressIssueTypeList,
        scanNumberList: '' // 条线码
      };
      if (params.problemItemType === 0) {
        params.collectStatusList = this.queryForm.params.collectStatusList;
      } else {
        params.waybillStatus = this.queryForm.params.collectStatusList;
      }
      const inputValList = [];
      if (this.queryForm.params.inputValue) {
        // 单号格式化，去除空格
        const orderNumber = this.queryForm.params.inputValue.split(/[(\r\n)\r\n]+/);
        orderNumber.map((item) => {
          if (item) {
            inputValList.push(item.trim());
          }
        });
      }
      if (inputValList.length === 0) {
        if (this.timeValue && this.timeValue.length > 0) {
          if (this.queryForm.params.timeType === 1) {
            params.problemCreateStartTime = this.timeValue[0];
            params.problemCreateEndTime = this.timeValue[1];
          } else if (this.queryForm.params.timeType === 2) {
            params.problemStartTime = this.timeValue[0];
            params.problemEndTime = this.timeValue[1];
          } else {
            params.closeStartTime = this.timeValue[0];
            params.closeEndTime = this.timeValue[1];
          }
        } else {
          this.$message.error(this.$t('GlobalSetObj.selectTime'));
          return 0;
        }
      } else {
        this.timeValue = [];
      }
      if (this.queryForm.params.numberType === 0) {
        // 条线码
        params.scanNumberList = inputValList.join('\n');
      } else if (this.queryForm.params.numberType === 1) {
        params.orderNumberList = inputValList.join('\n');
      } else if (this.queryForm.params.numberType === 2) {
        params.packageNumber = inputValList.join('\n');
      } else if (this.queryForm.params.numberType === 3) {
        params.waybillNumberList = inputValList.join('\n');
      } else if (this.queryForm.params.numberType === 4) {
        params.scanNumberList = inputValList.join('\n');
      }
      if (this.queryForm.params.siteType === 0) {
        params.problemSiteNameList = this.queryForm.params.siteSelectList;
      } else {
        params.preDeliverNameList = this.queryForm.params.siteSelectList;
      }
      return params;
    },
    // 查询
    getSearch() {
      const data = {
        pageNumber: this.queryForm.pageNumber,
        pageSize: this.queryForm.pageSize,
        params: {}
      };
      data.params = this.queryParam();
      console.log(data.params, 'data.params');
      if (data.params !== 0) {
        collectProblemPage(data).then((res) => {
          if (res.code === 200) {
            this.queryForm.total = res.data.total;
            this.tableData = res.data.records;
          }
        });
      }
    },
    // 导出
    exportOrder() {
      const data = this.queryParam();
      this.$refs.exportTipRef.handleSelectExportOpen(data);
    },
    // 获取最近一星期时间
    getTimer() {
      const day = new Date();
      const brazilTime = day.toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' });
      const today = dayjs(brazilTime).format('YYYY-MM-DD');
      this.timeValue = [today + ' 00:00:00', today + ' 23:59:59'];
    },
    enterSearch() {
      this.queryForm.pageNumber = 1;
      this.getSearch();
    },
    // 重置
    resetForm() {
      this.queryForm.pageNumber = 1;
      this.getTimer();
      this.queryForm.params = {
        siteType: 0,
        collectStatusList: [],
        siteSelectList: [],
        customerIdList: [], // 客户名称
        merchantCodeList: [], // 商户号
        problemItemType: Number(this.activeName),
        inputValue: '',
        receiveStates: [],
        problemTypeIdList: [], // 问题件原因
        numberType: 0, // 单号类型: 0-运单号, 1-扫描单号
        timeType: 1, // 时间类型: 1-登记时间, 2-最新回复时间
        addressIssueTypeList: []
      };
      if (this.activeName === '1') {
        this.queryForm.params.numberType = 3;
      }
      this.getSearch();
      this.getMerchantList('');
      this.getCustomerPage('');
    },
    // 点击分页
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getSearch();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.getSearch();
    },
    remoteGetSiteList(val) {
      const value = val || '';
      siteFuzzyQuery(value).then((res) => {
        if (res.code === 200) {
          this.siteList = res.data;
        }
      });
    },
    // 获取商户列表
    getMerchantList(val = '', flag) {
      const data = {
        pageSize: 20,
        pageNumber: 1,
        params: {
          merchantName: ''
        }
      };
      if (flag) {
        if (this.merchantList.length === 0) {
          apimerchantName(data).then((res) => {
            if (res.code === 200) {
              this.merchantList = res.data.records;
            }
          });
        }
      } else {
        data.params.merchantName = val;
        apimerchantName(data).then((res) => {
          if (res.code === 200) {
            this.merchantList = res.data.records;
          }
        });
      }
    },
    // 州
    getAddress() {
      // level 0 州    1 城市   2 地区
      const params = {
        level: 0,
        parentId: ''
      };
      getLgAreaListData(params, false).then((res) => {
        if (res.code === 200) {
          this.StateList = res.data.map((item) => {
            return {
              id: item.id,
              label: `${item.nameEn}`
            };
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
  padding: 0 15px;
  padding-bottom: 15px;
}

::v-deep {
  .drawerClass header {
    border-bottom: 1px solid #aaa !important;
    margin-bottom: 0 !important;
    padding: 20px 20px 20px !important;
  }
}

.el-form--label-top ::v-deep .el-form-item__label {
  width: 100% !important;
}

.selectLabel ::v-deep .el-input__inner {
  height: 28px !important;
  line-height: 28px !important;
  border: none;
  font-weight: bold;
  text-align: left;
  padding: 0;
}

.selectLabel ::v-deep .el-input__icon {
  line-height: 28px !important;
}

.selectType ::v-deep .el-input--suffix .el-input__inner {
  border: none !important;
  font-weight: bold;
  font-size: 14px;
  text-align: left;
}

.textOperator {
  color: #00A551;
  font-size: 22px;
  cursor: pointer;
}

.textOperator2 {
  margin-top: -5px;
  color: #00A551;
  font-size: 22px;
  cursor: pointer;
}

.verifier {
  color: #00A551;
  cursor: pointer;
  padding: 0;
  font-size: 14px;
}
</style>
